module.exports = __webpack_public_path__ + "static/media/ic-account-kyc.7a6dae6d.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/ic-account-kyc.png
// module id = 646
// module chunks = 8